import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout';
import AsyncSidebarGlobalSettingsProducts from '@atlassian/jira-navigation-apps-sidebar-global-settings-products/src/async';
import { createEntry } from '@atlassian/jira-router';
import { getNavigationSidebarProductsSettingResource } from '@atlassian/jira-router-resources-navigation';
import { globalSettingsProductsSoftwareConfigRoute } from '@atlassian/jira-router-routes-legacy-global-settings-products-software-config-routes';

export const globalSettingsProductsSoftwareConfigRouteEntry = createEntry(
	globalSettingsProductsSoftwareConfigRoute,
	{
		layout: globalSettingsLayout,

		navigation: {
			sidebar: AsyncSidebarGlobalSettingsProducts,
		},

		resources: getNavigationSidebarProductsSettingResource(),
	},
);
